import { render, staticRenderFns } from "./Diagnostic.vue?vue&type=template&id=2158c7d3&scoped=true"
import script from "./Diagnostic.vue?vue&type=script&lang=js"
export * from "./Diagnostic.vue?vue&type=script&lang=js"
import style0 from "./Diagnostic.vue?vue&type=style&index=0&id=2158c7d3&prod&lang=scss"
import style1 from "./Diagnostic.vue?vue&type=style&index=1&id=2158c7d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2158c7d3",
  null
  
)

export default component.exports